import * as navigationGuardMSEntra from './navigationGuardMSEntra'
import * as navigationGuardOidc from './navigationGuardOidc'

let navigationGuardModule: any

const setNavigationGuardModule = async (useMSEntra: boolean) => {
  if (useMSEntra) {
    navigationGuardModule = navigationGuardMSEntra
    return
  }
  navigationGuardModule = navigationGuardOidc
}

export const navigationGuard = {
  init: async (useMSEntra: boolean) => {
    await setNavigationGuardModule(useMSEntra)
  },
  checkThatUserIsLoggedIn: () => navigationGuardModule.checkThatUserIsLoggedIn()
}
